/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LISCaseListPatient = {
    readonly id?: number;
    readonly clinic_id?: number;
    first_name: string;
    last_name?: string | null;
    date_of_birth?: string | null;
    readonly updated_at?: string;
    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    sex?: LISCaseListPatient.sex | null;
    middle_initial?: string | null;
    external_patient_id?: string | null;
    /**
     * MRN / medical record number for the patient from the source system
     */
    medical_record_number?: string | null;
}

export namespace LISCaseListPatient {

    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    export enum sex {
        M = 'M',
        F = 'F',
        O = 'O',
        U = 'U',
        A = 'A',
    }


}
